module.exports = __webpack_public_path__ + "img/title1.44896045.webp";